import * as yup from 'yup';

export const AddItemFormValidation = yup.object().shape({
  itemName: yup.string().trim().required('Elements Inspected is required field'),
});
